import img_1 from '../image/Portfolio/img_1.jpg'
import img_2 from '../image/Portfolio/img_2.jpg'
import img_3 from '../image/Portfolio/img_3.jpg'
import img_4 from '../image/Portfolio/img_4.jpg'
import img_5 from '../image/Portfolio/img_5.jpg'
import img_6 from '../image/Portfolio/img_6.jpg'
import img_7 from '../image/Portfolio/img_7.jpg'
import img_8 from '../image/Portfolio/img_8.jpg'
import img_9 from '../image/Portfolio/img_9.jpg'
import img_10 from '../image/Portfolio/img_10.jpg'
import img_11 from '../image/Portfolio/img_11.jpg'
import img_12 from '../image/Portfolio/img_12.jpg'
import img_13 from '../image/Portfolio/img_13.jpg'
import img_14 from '../image/Portfolio/img_14.jpg'
import img_15 from '../image/Portfolio/img_15.jpg'

export const phone = '+79101740505'


export const arrAdvantages = [{text:'Профессиональные МАСТЕРА'}, {text:'Работаем без ВЫХОДНЫХ'}, {text:'Моноголетний ОПЫТ'}, {text:'Опepaтивный ВЫЕЗД'}, {text:'Персональный ПОДХОД'}, {text:'Демократичные ЦЕНЫ'},];


export const arrPortfolio = [ {image: img_1, title: 'генератор'}, {image: img_2, title: 'генератор'}, {image: img_3, title: 'генератор'}, {image: img_4, title: 'генератор'}, {image: img_5, title: 'генератор'}, {image: img_6, title: 'генератор'},];

export const arrPortfolioModal = [{image: img_1, title: 'генератор'}, {image: img_2, title: 'генератор'}, {image: img_3, title: 'генератор'}, {image: img_4, title: 'генератор'}, {image: img_5, title: 'генератор'}, {image: img_6, title: 'генератор'}, {image: img_7, title: 'генератор'}, {image: img_8, title: 'генератор'}, {image: img_9, title: 'генератор'}, {image: img_10, title: 'генератор'}, {image: img_11, title: 'генератор'}, {image: img_12, title: 'генератор'}, {image: img_13, title: 'генератор'}, {image: img_14, title: 'генератор'}, {image: img_15, title: 'генератор'},];